/* eslint-disable max-len */
import { Accordion, HeaderBody, AccordionDetails, AccordionSummary, Link, Typography, Box, Grid, } from "@fedsim/components"
import { memo, useState, } from "react"
import { PALETTE } from '@fedsim/constants'

import { APP_VERSION, } from "@fedsim/constants"

import { useFooterStyles, } from "./footer.style"

import { LegalNotice, } from "../legal"

const PrivacyPolicy = () => (
  <Box display="flex" flexDirection="column">
      <Box>
        Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use,
        communicate and disclose and make use of personal information. Please be aware that the terms of this policy can be changed at any
        time at the sole discretion of the creator. The following outlines our privacy policy
      </Box>
      <Box>
        Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.
      </Box>
      <Box>
        We will collect and use of personal information solely with the objective of filling those purposes specified by us and for other
        compatible purposes, unless we obtain the consent of the individual concerned or as required by law.
      </Box>
      <Box>
        We will only retain personal information as long as necessary for the fulfillment of those purposes.<Box>
        </Box>
        We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the
        individual concerned.
      </Box>
      <Box>
        Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should
        be accurate, complete, and up-to-date.
      </Box>
      <Box>
        We will make readily available to customers information about our policies and practices relating to the management of personal
        information.
      </Box>
      <Box>
        We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of
        personal information is protected and maintained.
      </Box>
  </Box>
)

export const Accordions = () => {
  const classes = useFooterStyles()
  const [expanded, setExpanded,] = useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <>
      <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
          <HeaderBody>Privacy Policy</HeaderBody>
        </AccordionSummary>
        <AccordionDetails>
          <PrivacyPolicy />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
        <AccordionSummary aria-controls="panel2bh-content" id="panel2bh-header">
          <HeaderBody>Legal notice; Notice of Non-Affiliation and disclaimer</HeaderBody>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.secondaryHeading}>For any further queries please contact via the feedback button.</Typography>
          <LegalNotice />
        </AccordionDetails>
      </Accordion>
    </>
  )
}

const Footer = () => {
  const classes = useFooterStyles()

  return (
    <>
      <Grid container className={classes.root} sx={{
        backgroundColor: 'black',
        color: PALETTE.FOOTERTEXT,
        '& a': {
          color: 'white',
          '&:hover': {
            color: PALETTE.ACCENT,
          },
        },
      }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Box display="flex" justifyContent="start" style={{ color: 'white' }}>
            <Link href="//x.com/FedSimulator">
              X/fedsimulator
            </Link>
            - Version {APP_VERSION}
            -
            Created by &nbsp;<Link target="_blank" rel="external noopener noreferrer" color="#fff" href="//www.github.com/azz0r">azz0r</Link>
          </Box>
          <Accordions />
        </Grid>
      </Grid>
    </>
  )
}

export default memo(Footer)
